// Per-page SEO for the CRA SPA (no SSR). Sets title / description / canonical / Open Graph /
// Twitter tags + JSON-LD, and restores the previous values on cleanup so SPA navigation
// doesn't leak page-specific tags onto other routes. Returns a cleanup fn for useEffect.
export function applyPageSeo({ title, description, canonical, image, imageAlt, jsonLd, seoKey = "page" }) {
  const restores = [];

  if (title) {
    const prev = document.title;
    document.title = title;
    restores.push(() => { document.title = prev; });
  }

  const setMeta = (attr, key, value) => {
    if (value == null) return;
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (el) {
      const prev = el.getAttribute("content");
      el.setAttribute("content", value);
      restores.push(() => el.setAttribute("content", prev));
    } else {
      el = document.createElement("meta");
      el.setAttribute(attr, key);
      el.setAttribute("content", value);
      document.head.appendChild(el);
      restores.push(() => el.remove());
    }
  };

  setMeta("name", "description", description);
  setMeta("property", "og:title", title);
  setMeta("property", "og:description", description);
  setMeta("property", "og:url", canonical);
  setMeta("property", "og:image", image);
  setMeta("name", "twitter:title", title);
  setMeta("name", "twitter:description", description);
  setMeta("name", "twitter:image", image);
  if (imageAlt) setMeta("property", "og:image:alt", imageAlt);

  if (canonical) {
    let link = document.head.querySelector('link[rel="canonical"]');
    if (link) {
      const prev = link.getAttribute("href");
      link.setAttribute("href", canonical);
      restores.push(() => link.setAttribute("href", prev));
    } else {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      link.setAttribute("href", canonical);
      document.head.appendChild(link);
      restores.push(() => link.remove());
    }
  }

  if (jsonLd) {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-seo", seoKey);
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);
    restores.push(() => script.remove());
  }

  return () => restores.forEach((fn) => fn());
}
